// Fonte única do blog: junta os 48 posts migrados do WordPress (posts.js, gerado)
// com os posts novos escritos à mão (postsExtra.js). Ordena do mais novo ao mais
// antigo e deriva o índice por slug e a lista de categorias.
import { posts as migrated } from "./posts";
import { postsExtra } from "./postsExtra";
import discarded from "./discarded.json";

// Posts descartados na curadoria (temas descontinuados). Continuam com 301 no
// _redirects para não gerar 404 nas URLs antigas, mas somem do blog.
const DISCARDED = new Set(discarded.map((d) => d.slug));

export const posts = [...postsExtra, ...migrated]
  .filter((p) => !DISCARDED.has(p.slug))
  .sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : 0));

export const postsBySlug = Object.fromEntries(posts.map((p) => [p.slug, p]));

export const categories = (() => {
  const seen = new Map();
  for (const p of posts)
    for (const c of p.categories || [])
      if (!seen.has(c.slug)) seen.set(c.slug, c);
  return [...seen.values()].sort((a, b) => a.name.localeCompare(b.name, "pt-BR"));
})();

// Carrega o corpo HTML de um post sob demanda. Cada corpo é um módulo em
// src/content/{slug}.js — o import() dinâmico vira um chunk separado por post,
// fora do bundle principal, e funciona em qualquer host (sem depender de fetch
// nem de regras de rewrite do servidor).
export async function loadPostBody(slug) {
  const mod = await import(
    /* webpackChunkName: "post" */ `../content/${slug}.js`
  );
  return mod.default;
}
